import React from 'react';
import axios from 'axios';
import { useLocation } from 'react-router-dom';
import { getReasonPhrase } from 'http-status-codes';
import API from '@wheeebo/polaris-api';
import { useSnackbar } from '@wheeebo/polaris-snackbar';
function getErrorMessage(err) {
    if (axios.isAxiosError(err)) {
        return err.message;
    }
    else if (err instanceof Error) {
        return err.message;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
    }
    else if (err.hasOwnProperty('message')) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return err.message;
    }
    return `${err}`;
}
function useErrorHandler() {
    const { showError: showSnackError } = useSnackbar();
    const location = useLocation();
    const emitJsErrorEvent = React.useCallback(async (err) => {
        if (!err) {
            return;
        }
        if (err instanceof Error) {
            const e = err;
            await API.Track.emitJsErrorEvent('', {
                name: e.name,
                message: e.message,
                stack: e.stack,
                path: location.pathname,
                search: location.search,
                hash: location.hash,
            });
        }
    }, [location.pathname, location.search, location.hash]);
    const showError = React.useCallback((err) => {
        if (!err) {
            return;
        }
        if (axios.isAxiosError(err)) {
            // Gin AbortWithError bodies carry {"error": "…"} — surface the
            // server-side reason (e.g. "preflight failed: no 3D GNSS fix")
            // instead of only the HTTP reason phrase.
            const detail = err.response?.data?.error;
            const msg = detail
                ? `API error: ${detail}`
                : `API error: ${getReasonPhrase(err.response?.status || 999)}`;
            showSnackError(msg);
            console.error(msg);
        }
        else {
            const msg = getErrorMessage(err);
            if (msg) {
                showSnackError(msg.toString());
            }
            const stack = err.stack;
            if (stack) {
                console.error(stack);
            }
        }
    }, [showSnackError]);
    const showAndEmitJsErrorEvent = React.useCallback((err) => {
        if (!err) {
            return;
        }
        if (!axios.isAxiosError(err)) {
            emitJsErrorEvent(err);
        }
        showError(err);
    }, [emitJsErrorEvent, showError]);
    return { showError, emitJsErrorEvent, showAndEmitJsErrorEvent };
}
export default useErrorHandler;
